export default __webpack_public_path__ + "static/media/notification_high-intensity.8dec8686.wav";